import React from 'react';

const TermsOfService = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px', fontFamily: 'system-ui, -apple-system, sans-serif', lineHeight: '1.6' }}>
      <h1 style={{ borderBottom: '2px solid #eee', paddingBottom: '10px' }}>Terms of Service</h1>
      <p><strong>Streamers Connected Media Ltd</strong></p>
      <p><em>Last updated: 3 May 2026</em></p>

      <hr style={{ margin: '30px 0', border: 'none', borderTop: '1px solid #eee' }} />

      <h2>1. Agreement to Terms</h2>
      <p>
        By accessing or using the Streamers Connected platform ("Service"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our Service.
      </p>
      <p>
        <strong>Important:</strong> By using our Service, you are also agreeing to be bound by the{' '}
        <a href="https://www.youtube.com/t/terms" target="_blank" rel="noopener noreferrer">YouTube Terms of Service</a>{' '}
        and the{' '}
        <a href="https://www.tiktok.com/legal/page/global/terms-of-service/en" target="_blank" rel="noopener noreferrer">TikTok Terms of Service</a>.
        Our platform utilises YouTube API Services and TikTok API Services to display creator analytics and, where creators have explicitly authorised access via OAuth, first-party performance data.
      </p>

      <h2>2. Description of Service</h2>
      <p>
        Streamers Connected is an analytics platform that displays publicly available data from content creation platforms including YouTube, Twitch, and TikTok. We provide dashboards displaying metrics such as views, likes, and comments to help brands and agencies evaluate creator partnerships.
      </p>
      <p>
        Certain metrics displayed on our platform, including Engagement Rate, Estimated Impressions, and Watch Hours, are calculated by Streamers Connected and are not provided directly by YouTube or other platforms. These estimated metrics are clearly labelled and may differ from official platform analytics.
      </p>

      <h2>3. Account Access</h2>
      <p>
        Accounts on our platform are created and managed by Streamers Connected Media Ltd. Access to dashboards is provided via secure links distributed to authorised clients. You are responsible for maintaining the confidentiality of any access credentials or links provided to you.
      </p>

      <h2>4. Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Share your dashboard access links with unauthorised parties</li>
        <li>Attempt to access data or areas of the Service you are not authorised to view</li>
        <li>Use the Service for any unlawful purpose</li>
        <li>Interfere with or disrupt the Service or servers connected to the Service</li>
        <li>Scrape, copy, or redistribute data from the Service without written permission</li>
      </ul>

      <h2>5. Intellectual Property</h2>
      <p>
        All content, features, and functionality of the Service, including but not limited to text, graphics, logos, and software, are owned by Streamers Connected Media Ltd and are protected by copyright, trademark, and other intellectual property laws.
      </p>
      <p>
        Data displayed from third-party platforms (YouTube, Twitch, TikTok) remains the property of those respective platforms and their content creators.
      </p>

      <h2>6. Third-Party Services</h2>
      <p>
        Our Service uses YouTube API Services to retrieve and display publicly available creator data. By using our Service, you acknowledge and agree to be bound by the{' '}
        <a href="https://www.youtube.com/t/terms" target="_blank" rel="noopener noreferrer">YouTube Terms of Service</a>.
      </p>
      <p>
        Our Service also uses TikTok API Services. Where a creator chooses to connect their TikTok account via OAuth, we access only the data covered by the permission scopes the creator explicitly grants — typically profile information (username, display name, follower count, profile image) and performance data (views, likes, comments, shares) for videos the creator submits as part of a brand campaign. Creators may revoke this access at any time via their TikTok account settings, which will immediately stop further data collection. We use this data solely to generate campaign performance reports for the brands a creator has agreed to work with, and we do not sell, share, or otherwise disclose creator data to third parties outside the scope of those campaigns. By using our Service, you acknowledge and agree to be bound by the{' '}
        <a href="https://www.tiktok.com/legal/page/global/terms-of-service/en" target="_blank" rel="noopener noreferrer">TikTok Terms of Service</a>{' '}
        and the{' '}
        <a href="https://www.tiktok.com/legal/page/global/privacy-policy/en" target="_blank" rel="noopener noreferrer">TikTok Privacy Policy</a>.
      </p>

      <h2>7. Disclaimer of Warranties</h2>
      <p>
        The Service is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not guarantee the accuracy, completeness, or timeliness of any data displayed on the platform.
      </p>
      <p>
        Estimated metrics calculated by Streamers Connected (including Engagement Rate, Estimated Impressions, and Watch Hours) are provided for informational purposes only and should not be considered official platform data.
      </p>

      <h2>8. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, Streamers Connected Media Ltd shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use of the Service.
      </p>

      <h2>9. Changes to Terms</h2>
      <p>
        We reserve the right to modify these Terms at any time. We will notify users of any material changes by updating the "Last updated" date at the top of this page. Your continued use of the Service after any changes constitutes acceptance of the new Terms.
      </p>

      <h2>10. Governing Law</h2>
      <p>
        These Terms shall be governed by and construed in accordance with the laws of England and Wales, without regard to its conflict of law provisions.
      </p>

      <h2>11. Contact Us</h2>
      <p>If you have any questions about these Terms, please contact us:</p>
      <p>
        <strong>Streamers Connected Media Ltd</strong><br />
        58 Croydon Road<br />
        Caterham, CR3 6QB<br />
        United Kingdom
      </p>
      <p>Email: <a href="mailto:info@streamersconnected.com">info@streamersconnected.com</a></p>
    </div>
  );
};

export default TermsOfService;
